module.exports = __webpack_public_path__ + "static/media/aviva.81540956.jpg";